<p-dialog
  [(visible)]="visible"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '60vw', height: '80vh' }"
  [dismissableMask]="false"
  (onHide)="cancelDialog()"
  class="custom-dialog announcement-modal"
>
  <ng-template pTemplate="header">
    <div
      class="header-container d-flex justify-content-between align-items-center"
    >
      <div>
        <h4 class="header-title mb-0">
          #{{ clickedItem?.id }} {{ clickedItem?.topic }}
        </h4>
        <span class="header-subtitle">
          {{ clickedItem?.startDate | dateFormat }} -
          {{ clickedItem?.endDate | dateFormat }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="chat-box-area style-2">
    <div class="read-content dz-scroll">
      <div class="read-content-body px-3">
        <div class="inner-html-container">
          <div [innerHTML]="clickedItem?.content | safeHtml"></div>
        </div>

        <div *ngIf="clickedItem?.announcementFiles?.length > 0" class="mt-3">
          <h6>Uploaded Files:</h6>
          <ul class="list-unstyled d-flex flex-wrap">
            <li
              *ngFor="let file of clickedItem?.announcementFiles"
              class="file-item text-center me-4 mb-4"
            >
              <i [ngClass]="getFileIcon(file?.mimeType)" class="file-icon"></i>
              <button
                type="button"
                class="btn file-link"
                (click)="downloadFile(file)"
              >
                <p>{{ file.fileName }}</p>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="custom-footer">
      <button type="button" class="btn btn-danger" (click)="cancelDialog()">
        {{ "common.close" | translate }}
      </button>
      <button
        *ngIf="isAnnouncementRead(clickedItem)"
        type="button"
        class="btn btn-success"
        (click)="onPressSave()"
      >
        {{ "user-announcement.modal.read-understand" | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
